module.exports = __webpack_public_path__ + "assets/ukrr.418d273a2b44605adf366a4fb42dc628.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/home/ukrr.png
// module id = 336
// module chunks = 0